import Api from "../api";
let uri = "/api/ed/curso";

export const getCursos = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/list`, data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const adminCurso = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) => console.log(error));
};

export const createCurso = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) => console.log(error));
};

export const editCurso = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(`${uri}`, data)
    .then((resp) => resp)
    .catch((error) => console.log(error));
};

export const createDetalleCurso = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/detalle`, data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const asignaciones = (data) => {
  return Api.getInstance()
    .executeQuery("api/ed/asignaciones", data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const editCategoria = (data) => {
  return Api.getInstance()
    .executeUpdateQuery(`${uri}`, data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const deleteCategoria = (data) => {
  return Api.getInstance()
    .executeDeleteQuery(`${uri}`, data)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const categoriaCurso = () => {
  return Api.getInstance()
    .executeGetQuery(`/api/ed/categoria/curso`)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const cursoCategoria = (categoria) => {
  return Api.getInstance()
    .executeGetQuery(`/api/ed/curso/categoria/${categoria}`)
    .then((resp) => resp.data)
    .catch((error) => console.log(error));
};

export const asignCurso = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/asignacion", data)
    .then((res) => res.data);
};

export const getCursosUsuario = (data) => {
  return Api.getInstance()
    .executeQuery("/api/ed/cursos/usuario", data)
    .then((res) => res.data);
};

export const postProgresoCurso = (data) => {
  return Api.getInstance()
    .executeQuery(uri + "/progreso", data)
    .then((res) => res.data);
};

export const getContenidoCurso = (data) => {
  return Api.getInstance()
    .executeQuery("api/ed/contenido/curso", data)
    .then((res) => {
      if (!res.data) return [];

      const activeContent = res.data.filter((item) => Boolean(item.estado));

      const activeParentIds = new Set(
        activeContent
          .filter((item) => item.idContenidoPadre === null)
          .map((item) => item.idContenidoCurso)
      );

      return activeContent.filter((item) => {
        if (item.idContenidoPadre === null) return true;

        return activeParentIds.has(item.idContenidoPadre);
      });
    });
};

export const getCursoDetalle = (data) => {
  return Api.getInstance()
    .executeQuery(`${uri}/list`, data)
    .then((resp) => resp.data?.[0] || null)
    .catch((error) => console.log(error));
};

export const getEncuestaCurso = (data) => {
  return Api.getInstance()
    .executeQuery("/api/ed/encuesta/list", data)
    .then((resp) => {
      const activeSurveys =
        resp.data?.filter((survey) => Boolean(survey.estado)) || [];
      if (activeSurveys.length > 0) {
        const survey = activeSurveys[0];
        survey.preguntas =
          survey.preguntas
            ?.filter((pregunta) => Boolean(pregunta.estado))
            .map((pregunta) => ({
              ...pregunta,
              respuestas:
                pregunta.respuestas?.filter((respuesta) =>
                  Boolean(respuesta.estado)
                ) || [],
            })) || [];
        return survey;
      }
      return null;
    })
    .catch((error) => console.log(error));
};
